import { httpClient } from "./httpClient";
import { PageResponse } from "@/types/http.type";
import { buildQueryParams } from "@/utils/build-query-params";
import { AbrangenciaNivelEnum, RoleFiltrosCriteria, RoleFiltrosOptions } from "@workflow/types";

export type { RoleFiltrosCriteria, RoleFiltrosOptions } from "@workflow/types";

export interface Permissao {
  id: number;
  nome: string;
}

export interface Role {
  id: number;
  nome: string;
  permissoes: Permissao[];
  /** Total de pessoas ATIVAS vinculadas (vem da listagem paginada). */
  totalPessoasAtivas?: number;

  /** Nível de ABRANGÊNCIA (visão de linhas) do cargo. */
  abrangenciaNivel?: AbrangenciaNivelEnum;
  /** Nível de SENSIBILIDADE (visão de campos) do cargo. */
  sensibilidadeNivel?: AbrangenciaNivelEnum;
}

interface AssignRolesDTO {
  userId: number;
  roleIds: number[];
}

interface IRoleService {
  getRoles(): Promise<Role[]>;
  listRolesPaginado(criteria: RoleFiltrosCriteria): Promise<PageResponse<Role>>;
  getFiltros(): Promise<RoleFiltrosOptions>;
  assignRolesToUser(data: AssignRolesDTO): Promise<void>;
}

class RoleService implements IRoleService {
  private readonly basePath = "/api/v1/roles";

  public async getRoles(): Promise<Role[]> {
    return await httpClient.get<Role[]>(this.basePath);
  }

  public async listRolesPaginado(criteria: RoleFiltrosCriteria): Promise<PageResponse<Role>> {
    let url = `${this.basePath}/listagem`;
    if (criteria) {
      const query = buildQueryParams(criteria);
      if (query) url += "?" + query;
    }
    return await httpClient.get<PageResponse<Role>>(url);
  }

  public async getFiltros(): Promise<RoleFiltrosOptions> {
    return await httpClient.get<RoleFiltrosOptions>(`${this.basePath}/filtros`);
  }

  public async assignRolesToUser(data: AssignRolesDTO): Promise<void> {
    await httpClient.put(`${this.basePath}/assign-to-user`, data);
  }
}

export const roleService = new RoleService();
